// extracted by mini-css-extract-plugin
export default {"primaryScrollbar":"globalStyles_primaryScrollbar__eE4rU","competencies":"Skills_competencies__Iqpq+","mask":"Skills_mask__Wt7k7"};